/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ProvisioningNotitificationActionEnum = 'NEW' | 'UPDATE' | 'SUSPEND' | 'TERMINATE';

export const ProvisioningNotitificationActionEnum = {

    NEW: 'NEW' as ProvisioningNotitificationActionEnum,

    UPDATE: 'UPDATE' as ProvisioningNotitificationActionEnum,

    SUSPEND: 'SUSPEND' as ProvisioningNotitificationActionEnum,

    TERMINATE: 'TERMINATE' as ProvisioningNotitificationActionEnum
};

